<template>
<div>
<div
    v-if="label != null"
    class="label"
    :style="$rc.styleInputLabel()"
>
    {{label}}
</div>
<v-row>

    <v-col
        v-if="meta_data == null"
    >
        <v-skeleton-loader
            type="chip"
        />

    </v-col>

    <v-col
        v-if="meta_data != null && meta_data.length > 0"
    >
        <v-chip
            v-for="(item, index) in meta_data"
            :key="index"
            style="margin-right: 5px; margin-bottom: 5px;"
            :close="!read_only"
            @click:close="onRemove(index)"
            
        >
            <a 
                :href="blobURL(item)"
                target="_blank"
            >
                {{item.label}}
            </a>
        </v-chip>
    </v-col>

    <v-col
        v-if="meta_data != null && meta_data.length == 0"
    >
        <v-chip
            style="margin-right: 5px; margin-bottom: 5px;"
            :disabled="true"
            :close="!read_only"
        >
            {{empty_text}}
        </v-chip>

    </v-col>

    <v-col
        class="flex-grow-0 align-end"
    >
        <v-icon
            color="primary"
            v-on:click="onEdit"
            :disabled="read_only"
        >
            {{edit_icon}}
        </v-icon>
    </v-col>

    <m-edit-blobs-dialog
        ref="edit-blobs-dialog"
        v-on:ok="afterEditBlobsDialog($event)"
        :externally_visible="externally_visible"
        :accept="accept"
        :allow_multiple="allow_multiple"
        :limit_to_size="limit_to_size"
        :purpose="purpose"
        :title="dialog_title"
        :dialog_hint="dialog_hint"
    />
</v-row>
<v-row v-if="show_with_vcard">
    <v-col>
        <m-select-vcard
            label="Attach contact card (optional)"
            v-model="vcard_id"
            ref="select-contact-card"
            :endpoint="for_endpoint"
        />
    </v-col>
</v-row>
</div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            default: function() { return []; } 
        },

        edit_icon: {
            type: String,
            default: function() { return 'mdi-paperclip'; }
        },

        process_media: {
            type: Boolean,
            default: function() { return true; }
        },

        read_only: {
            type: Boolean,
            default: function() { return false; }
        },

        externally_visible: {
            type: Boolean,
            default: function () { return true; }
        },

        accept: {
            type: Array,
            default: function () { return []; }
        },

        allow_multiple: {
            type: Boolean,
            default: function () { return true; }
        },

        limit_to_size: {
            type: Number,
            default: function () { return -1; }
        },

        empty_text: {
            Type: String,
            default: function() { return "No Attachments"; }
        },

        purpose: {
            Type: String,
            default: function() { return "attachment"; }
        },

        label: {
            Type: String,
            default: function() { return null; }
        },

        dialog_title: {
            Type: String,
            default: function() { return 'Attach Files'; }
        },

        dialog_hint: {
            Type: String,
            default: function() { return null; }
        },

        show_with_vcard: {
            type: Boolean,
            default: function() { return false; }
        },

        vcard_id: {
            type: String,
            default: function() { return null; }
        },

        for_endpoint: {
            Type: String,
            default: function() { return null; },
        },
    },

    data() {
        return {
            meta_data: [],
        }
    },

    mounted () {
        this.updateMetaData();
    },
    
    methods: {
        updateMetaData()
        {
            this.meta_data = null;
            this.$forceUpdate();

            if ( this.value.length == 0 )
            {
                this.meta_data = [];
                return;
            }

            this.$rc.getBlobMetaDataMultiple(
                this.value,

                (data) => {
                    this.meta_data = data.meta_data;
                },

                () => {
                    this.$rc.alert('Error', 'Unable to get blob meta data');
                }
            )
        },

        onRemove(index)
        {
            let new_value = [];

            for ( let i = 0; i < this.value.length; i++ )
            {
                if ( i == index ) continue;
                new_value.push(this.value[i]);
            }

            this.$emit('input',new_value);
        },

        blobURL(meta_data)
        {
            return this.$rc.blobURL(meta_data.object_name);
        },

        onEdit() {
            this.$refs['edit-blobs-dialog'].showDialog(this.value, this.process_media);
        },

        afterEditBlobsDialog(new_blob_ids)
        {
            this.$emit('input', new_blob_ids);
        },
    },

    watch: {
        value(newValue, oldValue) 
        {
            this.updateMetaData();    
        }
    },
}
</script>

<style lang="scss" scoped>
.label
{
    margin-bottom: 7px;
}
</style>